// ======================================================================
// File Name       : ContentQuestionNewContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';
import {
  CONTENT_QUESTION_KIND,
  ANSWER_FORMULA,
  INPUT_LIMIT_LONG_ANSWER_DEFAULT,
} from '../../constants/ContentConstant';
import { W_REQUIRED } from '../../constants/MessageTemplate';
import ContentQuestionCommonInfo from '../../components/content/ContentQuestionCommonInfo';
import ContentNewBigQuestion from '../../components/content/ContentNewBigQuestion';
import ContentBigQuestionConfirmDialog from '../../components/content/ContentBigQuestionConfirmDialog';
import * as ContentQuestionRegisterAction from '../../actions/content/ContentQuestionRegisterAction';
import ContentSingleQuestion from '../../components/content/ContentSingleQuestion';
import ContentQuestionAddAnswerDialog from '../../components/content/ContentQuestionAddAnswerDialog';
import ContentSingleQuestionConfirmDialog from '../../components/content/ContentSingleQuestionConfirmDialog';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM } from '../../constants/index';
import { USER_TYPE } from '../../constants/UserConstants';
import { sortAnswerByCorrectNumbers } from '../../utils/ContentQuestionUtils';
import { CONTENT_QUESTION_LIST } from '../../constants/PathConstants';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ContentQuestionNewContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionInfo: {
        questionSecernId: '',
        questionTitle: '',
        questionContent: '',
        questionContentType: '0',
        answerFormula: ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER,
        optionMarkKind: '0',
        optionRandomUse: false,
        inputLimitType: false,
        inputLimit: '',
        questionViewDirection: '0',
        absolutePoint: '',
        questionAttributeScope: '',
        sankakuUseDistinct: false,
        hintUse: '',
        hintContent: '',
        hintHtmlUse: '0',
        hintZipFileName: '',
        hintZipFile: '',
        questionUseForm: '0',
        questionZipFileName: '',
        questionZipFile: '',
        explanationUse: '',
        explanationContent: '',
        explanationHtmlUse: '0',
        explanationZipFile: '',
        explanationZipFileName: '',
        subQuestionArray: [],
        limitTime: '',
        questionKind: CONTENT_QUESTION_KIND.SINGLE_QUESTION,
        correctNumber: '',
        correctAnswer: '',
        optionArray: [],
      },
      isShowAddAnswerDlg: false,
      isShowConfirmDlg: false,
      isClosedAdvanceSetting: true,
      buttonText: 'plus',
      answerInfo: [],
      answer: {
        index: null,
        answerChoice: '',
        isCorrectAnswer: false,
        correctAnswer: '',
        correctAnswerNumber: '',
        subAnswer: [],
      },
      subQuestionTemplate: {
        subQuestionIndex: '',
        subQuestionSecernId: '',
        subAbsolutePoint: '',
      },
      showAddSubQuestionModal: false,
      showConfirmModal: false,
      redirectToList: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleQuestionHtmlFileChange = this.handleQuestionHtmlFileChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleShowAddSubQuestionModal = this.handleShowAddSubQuestionModal.bind(this);
    this.handleOkBtnClick = this.handleOkBtnClick.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleHintHtmlFileChange = this.handleHintHtmlFileChange.bind(this);
    this.handleExplanationHtmlFileChange = this.handleExplanationHtmlFileChange.bind(this);
    this.handleQuestionPartHtmlFileChange = this.handleQuestionPartHtmlFileChange.bind(this);
    this.handleAddSubQuestion = this.handleAddSubQuestion.bind(this);
    this.handleRemoveSubQuestion = this.handleRemoveSubQuestion.bind(this);
    this.updateSubQuestionTemplate = this.updateSubQuestionTemplate.bind(this);
    this.handleConfirmModalCancel = this.handleConfirmModalCancel.bind(this);
    this.handleConfirmOk = this.handleConfirmOk.bind(this);
    this.openOrCloseAdvanceSetting = this.openOrCloseAdvanceSetting.bind(this);
    this.showAddAnswerDlg = this.showAddAnswerDlg.bind(this);
    this.handleAnswerChange = this.handleAnswerChange.bind(this);
    this.okAddAnswerDlg = this.okAddAnswerDlg.bind(this);
    this.cancelDlg = this.cancelDlg.bind(this);
    this.cancelConfirmDlg = this.cancelConfirmDlg.bind(this);
    this.removeAnswer = this.removeAnswer.bind(this);
    this.addSubAnswer = this.addSubAnswer.bind(this);
    this.handleSubAnswerChange = this.handleSubAnswerChange.bind(this);
    this.questionRegister = this.questionRegister.bind(this);
    this.okConfirmDlg = this.okConfirmDlg.bind(this);
    this.handleQuestionTypeChange = this.handleQuestionTypeChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { redirectToList } = nextProps;
    this.setState({ redirectToList });
  }
  handleChange(name, value) {
    let { questionInfo } = this.state;
    if (name === 'answerFormula') {
      if (value === '7') {
        questionInfo = { ...this.state.questionInfo, ...{ [name]: value } };
        questionInfo.inputLimit = INPUT_LIMIT_LONG_ANSWER_DEFAULT;
        questionInfo.inputLimitType = true;
        this.setState({
          answerInfo: [],
        });
      } else {
        questionInfo = { ...this.state.questionInfo, ...{ [name]: value } };
        questionInfo.inputLimitType = false;
        questionInfo.inputLimit = '';
        this.setState({
          answerInfo: [],
        });
      }
    } else {
      questionInfo = { ...this.state.questionInfo, ...{ [name]: value } };
    }
    this.setState({
      questionInfo,
    });
  }
  handleQuestionTypeChange(type) {
    const questionInfo = {
      ...this.state.questionInfo,
      questionKind: type,
      hintUse: '',
      hintContent: '',
      hintHtmlUse: '0',
      hintZipFileName: '',
      hintZipFile: '',
      questionUseForm: '0',
      questionZipFileName: '',
      questionZipFile: '',
      explanationUse: '',
      explanationContent: '',
      explanationHtmlUse: '0',
      explanationZipFile: '',
      explanationZipFileName: '',
    };
    this.setState({
      questionInfo,
    });
  }
  handleInputChange(name, value) {
    const questionInfo = { ...this.state.questionInfo, ...{ [name]: value } };
    this.setState({
      questionInfo,
    });
  }
  handleShowAddSubQuestionModal(flag) {
    this.setState({ showAddSubQuestionModal: flag });
  }
  handleConfirmModalCancel() {
    this.setState({ showConfirmModal: false });
  }
  handleConfirmOk() {
    this.setState({ showConfirmModal: false });
    const questionInfo = this.state.questionInfo;
    if (questionInfo.subQuestionArray) {
      for (const key in questionInfo.subQuestionArray) {
        questionInfo.subQuestionArray[key].subQuestionIndex = parseInt(key, 10) + 1;
      }
    }
    this.props.dispatch(ContentQuestionRegisterAction.RegisterQuestion(questionInfo));
  }
  handleOkBtnClick() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({ showConfirmModal: true });
    }
  }
  handleCheckboxChange(event) {
    const { name, checked } = event.target;
    let questionInfo = { ...this.state.questionInfo };
    if (name === 'inputLimitType' && checked === false) {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: checked },
        ...{ inputLimit: '' },
      };

      // Hide error message
      if (this.refsToValidate && this.refsToValidate.length) {
        this.refsToValidate.forEach((item) => {
          if (item.constructor.name === 'ContentSingleQuestion') {
            item.refsToValidate.forEach((item) => {
              if (item.props.name === 'inputLimit') {
                item.setState({ errorVisible: false });
              }
            });
          }
        });
      }
    } else if (name === 'explanationUse' && checked === false) {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: checked },
        ...{ explanationContent: '' },
        ...{ explanationHtmlUse: '0' },
        ...{ explanationZipFile: '' },
        ...{ explanationZipFileName: '' },
      };
    } else if (name === 'hintUse' && checked === false) {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: checked },
        ...{ hintContent: '' },
        ...{ hintHtmlUse: '0' },
        ...{ hintZipFile: '' },
        ...{ hintZipFileName: '' },
      };
    } else {
      questionInfo = {
        ...this.state.questionInfo,
        ...{ [name]: checked },
      };
    }
    this.setState({ questionInfo });
  }
  handleQuestionHtmlFileChange(event) {
    if (event.target.files.length !== 0) {
      let { questionInfo } = this.state;
      const questionZipFileName = event.target.files[0].name;
      questionInfo = {
        ...this.state.questionInfo,
        ...{ questionZipFile: event.target.files[0], questionZipFileName },
      };

      this.setState({
        questionInfo,
      });
    }
  }
  handleHintHtmlFileChange(event) {
    if (event.target.files.length !== 0) {
      const hintZipFileName = event.target.files[0].name;
      const questionInfo = {
        ...this.state.questionInfo,
        ...{ hintZipFile: event.target.files[0], hintZipFileName },
      };

      this.setState({
        questionInfo,
      });
    }
  }
  handleExplanationHtmlFileChange(event) {
    if (event.target.files.length !== 0) {
      const explanationZipFileName = event.target.files[0].name;
      const questionInfo = {
        ...this.state.questionInfo,
        ...{ explanationZipFile: event.target.files[0], explanationZipFileName },
      };

      this.setState({
        questionInfo,
      });
    }
  }
  handleQuestionPartHtmlFileChange(event) {
    if (event.target.files.length !== 0) {
      const questionZipFileName = event.target.files[0].name;
      const questionInfo = {
        ...this.state.questionInfo,
        ...{ questionZipFile: event.target.files[0], questionZipFileName },
      };

      this.setState({
        questionInfo,
      });
    }
  }

  parseDataToInt(subQuestion) {
    if (subQuestion) {
      if (subQuestion.subQuestionIndex) {
        subQuestion.subQuestionIndex = parseInt(subQuestion.subQuestionIndex, 10);
      }
      if (subQuestion.subAbsolutePoint) {
        subQuestion.subAbsolutePoint = parseInt(subQuestion.subAbsolutePoint, 10);
      }
    }
    return subQuestion;
  }

  handleAddSubQuestion(subQuestion) {
    const lastSubList = this.state.questionInfo.subQuestionArray;
    if (
      subQuestion.subQuestionIndex !== undefined &&
      subQuestion.subQuestionIndex !== null &&
      subQuestion.subQuestionIndex !== ''
    ) {
      lastSubList[subQuestion.subQuestionIndex] = this.parseDataToInt(subQuestion);
    } else {
      subQuestion.subQuestionIndex = lastSubList.length;
      lastSubList.push(this.parseDataToInt(subQuestion));
    }
    const questionInfo = {
      ...this.state.questionInfo,
      ...{ subQuestionArray: lastSubList },
    };
    this.setState({
      questionInfo,
      showAddSubQuestionModal: false,
    });
  }
  handleRemoveSubQuestion(subQuestionIndex) {
    const lastSubList = this.state.questionInfo.subQuestionArray;
    lastSubList.splice(subQuestionIndex, 1);
    const questionInfo = {
      ...this.state.questionInfo,
      ...{ subQuestionArray: lastSubList },
    };
    this.setState({
      questionInfo,
    });
  }
  updateSubQuestionTemplate(subQuestionDetail) {
    const lastTemplate = this.state.subQuestionTemplate;
    if (subQuestionDetail) {
      lastTemplate.subQuestionIndex = subQuestionDetail.subQuestionIndex;
      lastTemplate.subQuestionSecernId = subQuestionDetail.subQuestionSecernId;
      lastTemplate.subAbsolutePoint = subQuestionDetail.subAbsolutePoint;
    } else {
      lastTemplate.subQuestionIndex = null;
      lastTemplate.subQuestionSecernId = '';
      lastTemplate.subAbsolutePoint = '';
    }

    this.setState({
      subQuestionTemplate: lastTemplate,
    });
  }

  /**
   * Handle open or close attribute erea
   */
  openOrCloseAdvanceSetting() {
    this.setState({
      isClosedAdvanceSetting: !this.state.isClosedAdvanceSetting,
      buttonText: this.state.isClosedAdvanceSetting ? 'minute' : 'plus',
    });
  }

  handleAnswerChange(event) {
    const { name, value } = event.target;
    let { answer } = this.state.answer;
    if (name === 'answerChoice' || name === 'correctAnswerNumber' || name === 'correctAnswer') {
      answer = { ...this.state.answer, ...{ [name]: value } };
    } else if (name === 'isCorrectAnswer') {
      answer = {
        ...this.state.answer,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
    }
    this.setState({
      answer,
    });
  }

  showAddAnswerDlg(index) {
    const { answerInfo } = this.state;
    let answer = {
      index: null,
      answerChoice: '',
      isCorrectAnswer: false,
      correctAnswer: '',
      correctAnswerNumber: '',
      subAnswer: [],
    };
    if (index !== null) {
      answer = $.extend(true, {}, answerInfo[index]);
      answer.index = index;
    }
    this.setState({
      isShowAddAnswerDlg: true,
      answer,
    });
  }

  okAddAnswerDlg(index) {
    const { answer } = this.state;
    const { answerInfo } = this.state;
    if (answer && answer.subAnswer && answer.subAnswer.length) {
      let subAnswer = answer.subAnswer;
      subAnswer = subAnswer.filter(sub => !!sub);
      answer.subAnswer = subAnswer;
    }
    if (index == null) {
      answerInfo.push(answer);
    } else {
      answerInfo[index] = this.state.answer;
    }

    this.setState({ ...this.state, answerInfo, isShowAddAnswerDlg: false });
  }

  cancelDlg() {
    this.setState({ isShowAddAnswerDlg: false });
  }

  cancelConfirmDlg() {
    this.setState({ isShowConfirmDlg: false, questionDetail: {} });
  }

  removeAnswer(index) {
    const { answerInfo } = this.state;
    answerInfo.splice(index, 1);
    this.setState({ ...this.state, answerInfo });
  }

  addSubAnswer() {
    this.setState(prevState => ({
      ...prevState.answer.subAnswer.push(''),
    }));
  }

  handleSubAnswerChange(index, event) {
    const { subAnswer } = this.state.answer;
    const { value } = event.target;
    subAnswer[index] = value;

    this.setState({ ...this.state.answer, subAnswer });
  }

  questionRegister() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({
        isShowConfirmDlg: true,
        questionDetail: {},
      });
      this.okConfirmDlg(true);
    }
  }

  okConfirmDlg(isDialogDetail) {
    if (!isDialogDetail) {
      this.setState({
        isShowConfirmDlg: false,
      });
    }
    const { questionInfo } = this.state;
    questionInfo.optionArray = [];
    questionInfo.correctAnswer = '';
    questionInfo.correctNumber = '';
    let answerInfo = $.extend(true, [], this.state.answerInfo);
    if (isDialogDetail !== true &&
        questionInfo.answerFormula === ANSWER_FORMULA.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER) {
      answerInfo = sortAnswerByCorrectNumbers(answerInfo);
    }
    questionInfo.answerFormula = questionInfo.answerFormula || ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER;
    const selectiveCorrectAnswerSortList = {};
    for (const key in answerInfo) {
      const obj = {
        optionNumber: parseInt(key, 10) + 1,
        optionContent: '',
      };
      const answer = answerInfo[key];
      obj.optionContent = answer.answerChoice;
      if (answer.correctAnswer !== '') {
        obj.optionContent = answer.correctAnswer;
      }
      if (answer.isCorrectAnswer) {
        questionInfo.correctNumber += `_${parseInt(key, 10) + 1}`;
      }
      if (answer.correctAnswerNumber !== '') {
        questionInfo.correctNumber += `_${answer.correctAnswerNumber}`;

        // Create selectiveCorrectAnswerSortList
        const correctAnswerNumber = !isNaN(answer.correctAnswerNumber) ?
        parseInt(answer.correctAnswerNumber, 10) : null;
        if (correctAnswerNumber !== null) {
          selectiveCorrectAnswerSortList[correctAnswerNumber] = parseInt(key, 10) + 1;
        }
      }

      // End Create selectiveCorrectAnswerSortList
      if (answer.subAnswer.length > 0) {
        obj.optionContent += `/${answer.subAnswer.join('/')}`;
      }
      questionInfo.optionArray.push(obj);
      if (parseInt(questionInfo.answerFormula, 10) > 2) {
        questionInfo.correctAnswer += `__${obj.optionContent}`;
      }
    }
    // Handle CorrectNum for selectiveCorrectAnswer
    if (questionInfo.answerFormula === ANSWER_FORMULA.SELECTIVE_SORT_ANSWER) {
      questionInfo.correctNumber = '';
      if (selectiveCorrectAnswerSortList) {
        $.each(selectiveCorrectAnswerSortList, (index, value) => {
          questionInfo.correctNumber += `_${value}`;
        });
      }
    }

    questionInfo.correctAnswer = questionInfo.correctAnswer ?
    questionInfo.correctAnswer.substring(2) : '';
    questionInfo.correctNumber = questionInfo.correctNumber ?
    questionInfo.correctNumber.substring(1) : '';

    if (isDialogDetail === true) {
      this.setState({
        questionDetail: { ...questionInfo },
      });
    } else {
      this.setState({
        isShowConfirmDlg: false,
      },
      () => {
        this.props.dispatch(
          ContentQuestionRegisterAction.contentSingleQuestionRegister(questionInfo),
        );
      });
    }
  }

  render() {
    const redirectToList = this.state.redirectToList;
    if (redirectToList) {
      this.props.history.push(CONTENT_QUESTION_LIST);
    }
    const {
      isShowAddAnswerDlg,
      buttonText,
      isClosedAdvanceSetting,
      answer,
      isShowConfirmDlg,
      answerInfo,
    } = this.state;
    this.refsToValidate = [];
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_QUESTION_LIST}
          text="問題一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="問題の追加" />
        <Form className='form-horizontal'>
          <ContentQuestionCommonInfo
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            {...this.state.questionInfo}
            onchageQuestionType={this.handleQuestionTypeChange}
            onInputChange={this.handleInputChange}
          />
          <ContentSingleQuestion
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            {...this.state.questionInfo}
            answerInfo={answerInfo}
            isShowConfirmDlg={isShowConfirmDlg}
            answer={answer}
            isClosedAdvanceSetting={isClosedAdvanceSetting}
            buttonText={buttonText}
            isShowAddAnswerDlg={isShowAddAnswerDlg}
            handleQuestionHtmlFileChange={this.handleQuestionHtmlFileChange}
            handleExplanationHtmlFileChange={this.handleExplanationHtmlFileChange}
            handleHintHtmlFileChange={this.handleHintHtmlFileChange}
            handleCheckboxChange={this.handleCheckboxChange}
            handleChange={this.handleChange}
            openOrCloseAdvanceSetting={this.openOrCloseAdvanceSetting}
            showAddAnswerDlg={this.showAddAnswerDlg}
            removeAnswer={this.removeAnswer}
            questionRegister={this.questionRegister}
          />
          <ContentQuestionAddAnswerDialog
            showModal={isShowAddAnswerDlg}
            {...this.state.questionInfo}
            answerInfo={answerInfo}
            answer={answer}
            handleAnswerChange={this.handleAnswerChange}
            onOK={this.okAddAnswerDlg}
            onCancel={this.cancelDlg}
            addSubAnswer={this.addSubAnswer}
            handleSubAnswerChange={this.handleSubAnswerChange}
          />
          <ContentNewBigQuestion
            {...this.state.questionInfo}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            subQuestionTemplate={this.state.subQuestionTemplate}
            showAddSubQuestionModal={this.state.showAddSubQuestionModal}
            onClickAddBtn={this.handleShowAddSubQuestionModal}
            onOkBtnClick={this.handleOkBtnClick}
            onInputChange={this.handleInputChange}
            handleCheckboxChange={this.handleCheckboxChange}
            handleHintHtmlFileChange={this.handleHintHtmlFileChange}
            handleExplanationHtmlFileChange={this.handleExplanationHtmlFileChange}
            handleQuestionPartHtmlFileChange={this.handleQuestionPartHtmlFileChange}
            handleAddSubQuestion={this.handleAddSubQuestion}
            handleRemoveSubQuestion={this.handleRemoveSubQuestion}
            updateSubQuestionTemplate={this.updateSubQuestionTemplate}
            isClosedAdvanceSetting={isClosedAdvanceSetting}
            buttonText={buttonText}
            openOrCloseAdvanceSetting={this.openOrCloseAdvanceSetting}
            isRegister
          />
          <ContentBigQuestionConfirmDialog
            {...this.state.questionInfo}
            showModal={this.state.showConfirmModal}
            onOkClick={this.handleConfirmOk}
            onCancelClick={this.handleConfirmModalCancel}
          />
          <ContentSingleQuestionConfirmDialog
            showModal={isShowConfirmDlg}
            {...this.state.questionDetail}
            onOK={this.okConfirmDlg}
            onCancel={this.cancelConfirmDlg}
            answerInfo={answerInfo}
          />
        </Form>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  ...{ redirectToList: state.question.redirectToList },
});

export default connect(mapStateToProps)(ContentQuestionNewContainer);
